import { z } from 'zod';
import { LISTING_STATUSES } from '../constants/community.js';
import { CONDITIONS, CURRENCIES, VIDEO_SYSTEMS } from '../constants/inventory.js';
export const updatePublicProfileSchema = z.object({
    bio: z.string().max(500).optional(),
    location: z.string().max(100).optional(),
    profileSlug: z
        .string()
        .min(2)
        .max(100)
        .regex(/^[a-z0-9][a-z0-9-]*[a-z0-9]$/, 'Slug must be lowercase alphanumeric with hyphens, min 2 chars')
        .optional()
        .nullable(),
});
export const updateListingStatusSchema = z.object({
    listingStatus: z.enum(LISTING_STATUSES),
    askingPrice: z
        .string()
        .regex(/^\d{1,8}(\.\d{1,2})?$/, 'Invalid price format')
        .nullable()
        .optional(),
    listingCurrency: z.enum(CURRENCIES).optional(),
});
export const createWantedItemSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    category: z.string().min(1, 'Category is required').max(100),
    platform: z.string().min(1, 'Platform is required').max(100),
    conditionMin: z.enum(CONDITIONS).nullable().optional(),
    description: z.string().max(2000).optional().default(''),
    videoSystem: z.enum(VIDEO_SYSTEMS).nullable().optional(),
    subcategory: z.string().max(100).nullable().optional(),
    isPublic: z.boolean().optional().default(true),
});
export const updateWantedItemSchema = createWantedItemSchema.partial();
export const createOfferSchema = z.object({
    toUserId: z.string().uuid(),
    offeredItemIds: z.array(z.string().uuid()).default([]),
    requestedItemIds: z.array(z.string().uuid()).min(1, 'Must request at least one item'),
    moneyAmount: z
        .string()
        .regex(/^\d{1,8}(\.\d{1,2})?$/, 'Invalid amount')
        .nullable()
        .optional(),
    moneyCurrency: z.enum(CURRENCIES).optional(),
    message: z.string().max(2000).optional().default(''),
});
export const offerRespondSchema = z.object({
    action: z.enum(['accept', 'decline']),
});
export const offerQuerySchema = z.object({
    direction: z.enum(['sent', 'received', 'all']).default('all'),
    status: z.enum(['pending', 'all']).default('all'),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
export const notificationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(50).default(20),
    unreadOnly: z.coerce.boolean().default(false),
});
//# sourceMappingURL=community.js.map